/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2023
 * @flow
 */

import React from 'react';
import { Line } from 'react-chartjs-2';
import { Paper } from '@material-ui/core';
import useStyles from './useStyles';

const LineChart = ({ data, title }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.root} elevation={0}>
      <Line
        data={data}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: true,
              position: 'bottom',
            },
            title: {
              display: true,
              position: 'top',
              color: 'rgba(0, 0, 0, 0.54)',
              text: title,
              fullSize: true,
              font: {
                size: 14,
                weight: 400,
              },
            },
          },
        }}
      />
    </Paper>
  );
};

export default LineChart;
